function lightOrDark(a) {
	if (a.match(/^rgb/)) {
		a = a.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
		var b = a[1];
		var c = a[2];
		a = a[3];
	} else {
		a = +("0x" + a.slice(1).replace(5 > a.length && /./g, "$&$&"));
		b = a >> 16;
		c = a >> 8 & 255;
		a &= 255;
	}
	return 140 < Math.sqrt(.299 * b * b + .587 * c * c + .114 * a * a) ? "#000" : "#fff";
}

window.reorderSections = function () {
	$(".with-gutter").removeClass("with-gutter");
	$(".without-gutter").removeClass("without-gutter");
	$(".content-section.gutter--on").each(function () {
		$(this).parent().addClass("with-gutter");
		if ($(this).hasClass('parent-has-inner-padding')) {
			$(this).parent().addClass('has-inner-padding');
		}
	});
	$(".content-section.gutter--off").each(function () {
		$(this).parent().addClass("without-gutter");
	});
};

$(document).ready(function () {
	window.reorderSections();
});

(function () {
	// Force a fresh reload after browser back/forward navigation, so
	// dynamic state (cart count, filters, etc.) doesn't show stale data.
	// performance.navigation is deprecated; PerformanceNavigationTiming is the modern replacement.
	var navEntries = window.performance && performance.getEntriesByType && performance.getEntriesByType('navigation');
	var isBackForward = navEntries && navEntries.length
		? navEntries[0].type === 'back_forward'
		: (window.performance && performance.navigation && performance.navigation.type === 2);
	if (isBackForward) {
		location.reload();
	}
})();
